<template>
    <div>
        <limitless-page-header>
            <template #header-elements>
                <limitless-page-header-button
                    :route="{ name: 'cardseries.edit', params: { id: 0 } }"
                    icon="icon-plus3"
                >
                    Ny kortserie
                </limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <rednax-datatable :url="'/vue/cardseries'" :columns="table_columns" :filter="table_filter" @updateFilter="table_filter=$event" sort-by="SortNo" sort-order="asc" @rowclick="rowClick" history>
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                    </div>
                    <div class="col-lg-3" style="width: 200px;">
                        <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" id="chk-show-all" v-model="table_filter.show_hidden" :true-value="1" :false-value="0">
                            <label class="custom-control-label" for="chk-show-all">Visa alla</label>
                        </div>
                    </div>
                </div>

                <template #cell_CardSeriesID="{ row }">
                    <router-link :to="{ name: 'cardseries.edit', params: { id: row.CardSeriesID } }">{{ row.CardSeriesID }}</router-link>
                </template>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import BackendRepository from '@services/repositories/BackendRepository';

export default {
    name: 'CardSerieList',
    components: {
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        RednaxDatatable,
    },
    data: () => ({
        price_categories: {},
        table_filter: {
            search: '',
            show_hidden: 0,
        },
    }),
    mounted() {
        BackendRepository.getCardSeriesPriceCategories().then((res) => {
            this.price_categories = res;
        });
    },
    methods: {
        rowClick(row, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                window.open('/cardseries/' + row.CardSeriesID).focus();
            } else {
                this.$router.push({ name: 'cardseries.edit', params: { id: row.CardSeriesID } });
            }
        },
    },
    computed: {
        table_columns() {
            const vm = this;
            return [
                {
                    header: 'Serie',
                    data: 'CardSeriesID',
                    sortable: true,
                },
                {
                    header: 'Typ',
                    data: 'CardTypeID',
                    sortable: true,
                    render(row) {
                        return row.card_serie_type.CardType;
                    },
                },
                {
                    header: 'Benämning',
                    data: 'SeriesName',
                    sortable: true,
                },
                {
                    header: 'Ben.kort',
                    data: 'SeriesNameShort',
                    sortable: true,
                },
                {
                    header: 'Val',
                    data: 'NoOfChoices',
                    sortable: true,
                },
                {
                    header: 'Poäng',
                    data: 'IsPoints',
                    sortable: true,
                    render(row) {
                        return row.IsPoints ? 'Ja' : 'Nej';
                    },
                },
                {
                    header: 'Pris',
                    data: 'CardPrice',
                    sortable: true,
                    align_right: true,
                },
                {
                    header: 'Moms %',
                    data: 'VAT',
                    sortable: true,
                    align_right: true,
                },
                {
                    header: 'Lev. grupp',
                    data: 'DeliveryGroup',
                    sortable: true,
                },
                {
                    header: 'Prisgrupp',
                    data: 'CardPriceCat',
                    sortable: true,
                    render(row) {
                        return vm.price_categories[row.CardPriceCat] ? vm.price_categories[row.CardPriceCat].label : row.CardPriceCat;
                    },
                },
                {
                    header: 'Sort',
                    data: 'SortNo',
                    sortable: true,
                    align_right: true,
                },
            ];
        },
    },
};

</script>
